import React from "react";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import FormContainer from "../components/FormContainer";
import Map from "../components/Map";
import Help from "../components/Help";
import { FaHome, FaRegQuestionCircle } from "react-icons/fa";

const ErrScreen = () => {
  const navigate = useNavigate();
  return (
    <FormContainer>
      <Map
        titles={[
          {
            idx: "1",
            label: (
              <>
                <FaHome /> Home
              </>
            ),
            path: `/`,
            active: false,
          },
        ]}
      />
      <Row className="justify-content-center">
        <h1 style={{ color: "#00abff" }}>
          4
          <FaRegQuestionCircle className="fa-spin" />4
        </h1>
      </Row>
      <Row className="justify-content-center">
        <p>
          Looks like the page you were looking for is no longer here.
          <p>
            Let's go{" "}
            <strong style={{ color: "#00abff" }} onClick={() => navigate("/")}>
              home
            </strong>{" "}
            and try from there.
          </p>
        </p>
      </Row>
      <Help />
    </FormContainer>
  );
};

export default ErrScreen;
